export default __webpack_public_path__ + "static/media/newLogo.d27f2d70.png";